import { render, staticRenderFns } from "./DocAcaoRevisao.vue?vue&type=template&id=6b697abb&scoped=true&lang=pug&"
import script from "./DocAcaoRevisao.vue?vue&type=script&lang=js&"
export * from "./DocAcaoRevisao.vue?vue&type=script&lang=js&"
import style0 from "./DocAcaoRevisao.vue?vue&type=style&index=0&id=6b697abb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b697abb",
  null
  
)

export default component.exports